import { createReducer, on } from '@ngrx/store';
import { PaymentInternalCreate } from '../../../models/payment-internal.model';
import { PaymentOrderCreate } from '../../../models/payment-order-create.model';
import * as fromTemplatesActions from '../../actions/templates/templates.actions';

export const templatesFeatureKey = 'templates';

export interface State {
  templates: PaymentOrderCreate[] | null;
  selectedTemplate: PaymentOrderCreate[];
  templateDetails: PaymentOrderCreate | null;
  templateDetailsForm: PaymentOrderCreate | null;
  paymentOrderDetailsForm: PaymentOrderCreate | null;
  internalOrderDetailsForm: PaymentInternalCreate | null;
}

export const initialState: State = {
  templates: null,
  selectedTemplate: [],
  templateDetails: null,
  templateDetailsForm: null,
  paymentOrderDetailsForm: null,
  internalOrderDetailsForm: null
};

export const reducer = createReducer(
  initialState,
  on(fromTemplatesActions.loadTemplatesSuccess, (state, action) => {
    return {
      ...state,
      templates: action.templates
    };
  }),
  on(fromTemplatesActions.selectedPaymentTemplates, (state, action) => {
    let getStateSelectTemplates = [...state.selectedTemplate];
    if (action.data) {
      action.data.isChecked
        ? getStateSelectTemplates.push(action.data)
        : (getStateSelectTemplates = getStateSelectTemplates.filter(item => {
            return item.templateId !== action.data?.templateId;
          }));
    }
    return {
      ...state,
      selectedTemplate: getStateSelectTemplates
    };
  }),
  on(fromTemplatesActions.resetSelectedPaymentTemplates, (state, action) => {
    return {
      ...state,
      selectedTemplate: []
    };
  }),
  on(fromTemplatesActions.setTemplateDetails, (state, action) => {
    return {
      ...state,
      templateDetails: action.templateDetails
    };
  }),
  on(fromTemplatesActions.setTemplateDetailsForm, (state, action) => {
    return {
      ...state,
      templateDetailsForm: action.templateDetailsForm
    };
  }),
  on(fromTemplatesActions.resetTemplateDetailsForm, state => {
    return {
      ...state,
      templateDetailsForm: null
    };
  }),
  on(fromTemplatesActions.confirmPaymentOrderForm, (state, action) => {
    return {
      ...state,
      paymentOrderDetailsForm: action.paymentOrderDetailsForm
    };
  }),
  on(fromTemplatesActions.internalPaymentOrder, (state, action) => {
    return {
      ...state,
      internalOrderDetailsForm: action.internalOrderDetailsForm
    };
  })
);
